import React from "react";
import styled from "@emotion/styled";
import { breakpoints, mq } from "../../styles/mq";

type StatisticProps = {
	figure?: string;
	description?: string;
	secondary?: boolean;
};

export const Statistic = ({
	figure,
	description,
	secondary,
}: StatisticProps) => {
	const Statistic = styled("div")`
		opacity: ${secondary ? "0.2" : "1"};
		> h2 {
			font-size: 5rem;
			margin: 0;
			margin-top: 50px;
			padding: 0;
			line-height: 0.9;
			${mq(breakpoints.md)} {
				font-size: ${secondary ? "6rem" : "9rem"};
			}
		}
		span {
			display: block;
			margin-top: 20px;
			font-size: ${secondary ? "1rem" : "1.2rem"};
			color: rgb(247, 202, 73);
			text-transform: uppercase;
			font-weight: 900;
			letter-spacing: 5px;
		}
	`;
	return (
		<Statistic>
			<h2>
				{figure}+<span>{description}</span>
			</h2>
		</Statistic>
	);
};
